module.exports = __webpack_public_path__ + "img/section5_img1_4.0cfbfe8a.svg";